import {
  Box,
  Typography,
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { BaseDialog } from 'src/components/Dialogs/Base/BaseDialog'
import { CDN_PATH } from 'src/constants/global'
import styles from './DiscoveryDialog.scss'

interface DiscoveryDialogProps {
  isOpen: boolean
  onClose: () => void
}

const DiscoveryDialog = ({
  isOpen,
  onClose,
}: DiscoveryDialogProps): JSX.Element => (
  <BaseDialog isDiscoveryDialog isOpen={isOpen} onClose={onClose}>
    <Box className={styles.discoveryDialogContainer}>
      <Typography variant="h3Bold" color="primary.main">
        Spend smart with
        <br />
        your HSA or FSA 💰
      </Typography>
      <Box className={styles.discoveryDialogItemRow}>
        <Box className={styles.discoveryDialogItemIconContainer}>
          <CheckCircleIcon className={styles.discoveryDialogItemIcon} />
        </Box>
        <Box>
          <Typography variant="body3Bold" color="primary.main">Make your money go further</Typography>
          <Typography variant="body4" color="gray1.main">We handle eligibility. Guaranteed.</Typography>
        </Box>
      </Box>
      <Box className={styles.discoveryDialogItemRow}>
        <Box className={styles.discoveryDialogItemIconContainer}>
          <img
            className={styles.discoveryDialogItemIcon}
            src={`${CDN_PATH}/images/asset-receipt-icon.svg`}
            alt="Receipt icon"
          />
        </Box>
        <Box>
          <Typography variant="body3Bold" color="primary.main">Receipts, handled</Typography>
          <Typography variant="body4" color="gray1.main">Forget filing for reimbursements. We got you.</Typography>
        </Box>
      </Box>
      <Box className={styles.discoveryDialogItemRow}>
        <Box className={styles.discoveryDialogItemIconContainer}>
          <img
            className={styles.discoveryDialogItemIcon}
            src={`${CDN_PATH}/images/asset-card-icon.svg`}
            alt="Storefront icon"
          />
        </Box>
        <Box>
          <Typography variant="body3Bold" color="primary.main">Don&apos;t have your HSA/FSA card handy?</Typography>
          <Typography variant="body4" color="gray1.main">Use your credit card. We&apos;ll help with the rest.</Typography>
        </Box>
      </Box>
    </Box>
  </BaseDialog>
)

export {
  DiscoveryDialog,
  DiscoveryDialogProps,
}
